let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k2lsy")).then(() => parcelRequire('8mqjG'));